<template>
  <v-container style="max-height: 75vh;" class="scrollDesign">
    <v-layout row wrap>
      <v-flex ma-1 xs12 class="expandableContainer">
        <v-data-table :headers="parentsHeaders" :items="parents" :items-per-page="5" hide-details>
          <template v-slot:headers="props">
            <tr>
              <th v-for="header of props.headers" :key="header.text">{{ header.text }}</th>
            </tr>
          </template>
          <template v-slot:items="props">
            <td v-if="flags.status != 200">
              <v-edit-dialog :key="generalKey" :return-value.sync="props.item.firstName" lazy>
                {{ props.item.firstName }}
                <template v-slot:input>
                  <v-text-field
                    :key="generalKey"
                    v-model="props.item.firstName"
                    label="Nombre"
                    @keyup.enter="generalKey++"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td v-else>{{ props.item.firstName }}</td>
            <td v-if="flags.status != 200" class="text-xs-right">
              <v-edit-dialog :key="generalKey" :return-value.sync="props.item.lastName" lazy>
                {{ props.item.lastName }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.lastName"
                    :key="generalKey"
                    label="Apellidos"
                    @keyup.enter="generalKey++"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td v-else>{{ props.item.lastName }}</td>
            <td v-if="flags.status != 200" class="text-xs-right">
              <v-edit-dialog :key="generalKey" :return-value.sync="props.item.mail" lazy>
                {{ props.item.mail }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.mail"
                    label="Correo"
                    :key="generalKey"
                    @keyup.enter="generalKey++"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td v-else>{{ props.item.mail }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  props: ["parents", "flags"],
  data: () => ({
    parentsHeaders: [
      {
        text: "Nombre",
        sortable: false,
        value: "firstName",
        align: "center",
        sortable: true
      },
      {
        text: "Apellidos",
        sortable: false,
        value: "lastName",
        align: "center",
        sortable: true
      },
      {
        text: "Correo",
        sortable: false,
        value: "mail",
        align: "center",
        sortable: true
      }
    ],
    generalKey: 0
  })
};
</script>

<style scoped>
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}
</style>

<style scoped>
td,
th {
  width: 295px;
  max-width: 295px;
  min-width: 295px;
}
</style>

